import DeleteVendor from '../../pages/Vendor/DeleteVendor';
import { VendorController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';

const DeleteVendorContainer = ({ closeModal, goBack }) => {
	const [loading, setLoading] = useState(false);

  const onDelete = async id => {
    setLoading(true);
    const {
      status,
      errorMessage,
    } = await VendorController.deleteVendor(id)

    if (status === constant.Success) {
      setLoading(false);
      MimaToastUtil.success({
        message: constant.Success,
      });
      return closeModal();
    }
    setLoading(false);
    return MimaToastUtil.error({
      message: errorMessage,
    });
  };

	return (
		<DeleteVendor
			closeModal={closeModal}
			loading={loading}
      onDelete={onDelete}
			goBack={goBack}
		/>
	);
};

export default observer(DeleteVendorContainer);